import React, {FC, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {apiUrlWithStore} from "../../helper";
import {ChangepasSvg} from "../../svg";
import {setPopup, setPopupName} from "../../store/general";
import {CustomTextField} from "../../atoms";
import {IState} from "../../types/state";
import {adressesType, errorsType, inputStateType} from "./types";
import TextField from "../../atoms/customFields/TextField";
import TextArea from "../../atoms/customFields/TextArea";
import DropDown from "../../atoms/customFields/DropDown";
import DateField from "../../atoms/customFields/DateField";
import YesNoRadio from "../../atoms/customFields/YesNoRadio";
import RadioButton from "../../atoms/customFields/RadioButton";
import SelectField from "../../atoms/customFields/SelectField";
import cls from "./account.module.scss"
import {TranslationsType} from "../../types/homePageTypes";
import {setCompanyName} from "../../store/customer";

const initialState = {
    first_name: "",
    last_name: "",
    email: "",
    gender: "Male",
    date_of_birth: "",
    companyname: ""
}

interface IProps {
    customFieldGenerate: any,
    translationsData: TranslationsType
}

const AccountPageProfile: FC<IProps> = ({
                                            customFieldGenerate,
                                            translationsData
                                        }) => {
    const customer = useSelector((state: IState) => state.customer);
    const dispatch = useDispatch()
    const [address, setAddress] = useState<adressesType>();
    const [errors, setErrors] = useState<errorsType>();
    const [success, setSuccess] = useState<boolean>(false);
    const [input, setInput] = useState<inputStateType>(initialState);
    const [loading, setLoading] = useState<boolean>(false);
    const [urlValidate, setUrlValidate] = useState(true);

    const handleChange = (event: React.FormEvent<HTMLInputElement>, code?: string) => {
        const {name, value} = (event.target as HTMLInputElement);
        const regexDecimal = /^\d+(\.\d{0,100})?$/
        const regexInteger = /^\d+$/
        const regexUrl = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/
        const regexLettersOnly = /^[a-zA-Z]+$/
        const regexLettersAndNumbersOnly = /^[a-zA-Z0-9]+$/

        const filterValue = () => {
            if (code === "decimal" && !regexDecimal.test(value)) {
                if (regexDecimal.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            if (code === "integer" && !regexInteger.test(value)) {
                if (regexInteger.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            if (code === "url") {
                setUrlValidate(value !== "" ? regexUrl.test(value) : true);
            }
            if (code === "letter" && !regexLettersOnly.test(value)) {
                if (regexLettersOnly.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            if (code === "letter_number" && !regexLettersAndNumbersOnly.test(value)) {
                if (regexLettersAndNumbersOnly.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            return value
        }

        setInput({...input, [name]: filterValue()});
    }

    useEffect(() => {
        const abortController = new AbortController();
        const {signal} = abortController;

        if (customer.token) {
            fetch(apiUrlWithStore(`/api/customer/get?token=${customer.token}`), {signal})
                .then((response) => response.json())
                .then((res) => {
                    if (res) {
                        const gender = "Male"
                        const date_of_birth = "1999-09-09"
                        setInput({...res.data, gender, date_of_birth})
                        setAddress({...res.data, gender});
                    }
                })
                .catch((err) => console.error(err));
        }

        return function cleanUp() {
            abortController.abort();
        };
    }, [customer.token]);

    if (!address) {
        return null;
    }

    const handleClick = (event: { preventDefault: () => void; }) => {
        const newBodyResponse = {
            date_of_birth: input.date_of_birth,
            email: input.email,
            first_name: input.first_name,
            gender: 'Male',
            last_name: input.last_name,
            phone: input.phone,
            token: customer.token,
            ...input
        }
        dispatch(setCompanyName(input.companyname));
        event.preventDefault();
        setLoading(true);
        let option = {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(newBodyResponse),
        };

        fetch(apiUrlWithStore(`/api/customer/profile`), option)
            .then((response) => response.json())
            .then((res) => {
                setLoading(false);
                if (res.errors) {
                    setErrors(res.errors);
                } else {
                    setSuccess(true);
                    setErrors(undefined)
                }
            });
    };

    return (
        <div className={`${cls.card} ${cls["input-fields-parent"]}`}>
            {
                success
                && (
                    <div className="alert alert-success">
                        {translationsData.AccountUpdatedSuccessfully}
                    </div>
                )
            }
            <div className={cls["card-body"]}>
                <div className="d-flex">
                    <div className={`d-flex ${cls["personal-info-card"]}`}>
                        {customFieldGenerate.map((item: any, index: number) => {
                            switch (item.type) {
                                case "textfield":
                                    if (item.attribute_code === 'contactpersonphonenumber') {
                                        return null;
                                    } else if ((item.attribute_code === 'contactpersonemail')) {
                                        return null
                                    } else {
                                        return (
                                            <div
                                                className={`${cls["form-group"]} ${cls["input-paddings"]}`}
                                                style={{width: "100%"}}
                                            >
                                                <TextField
                                                    item={item}
                                                    index={index}
                                                    // @ts-ignore
                                                    savedFormData={input?.[item.attribute_code] ? input : address}
                                                    handleChange={handleChange}
                                                    urlValidate={urlValidate}
                                                    translationsData={translationsData}
                                                    setCompanyName={setCompanyName}
                                                />
                                            </div>
                                        )
                                    }
                                case "textarea":
                                    return (
                                        <div
                                            className={`${cls["form-group"]} ${cls["input-paddings"]}`}
                                            style={{width: "100%"}}
                                        >
                                            <TextArea
                                                item={item}
                                                index={index}
                                                // @ts-ignore
                                                savedFormData={input?.hasOwnProperty(item.attribute_code) ? input : address}
                                                handleChange={
                                                    handleChange as unknown as
                                                        (event: {
                                                            target: { value: string, name?: string }
                                                        }, item: string) => void
                                                }
                                                translationsData={translationsData}
                                            />
                                        </div>
                                    )
                                case "dropdown":
                                    return (
                                        <div
                                            className={`${cls["form-group"]} ${cls["input-paddings"]}`}
                                            style={{width: "100%"}}
                                        >
                                            <DropDown
                                                item={item}
                                                index={index}
                                                // @ts-ignore
                                                savedFormData={input?.hasOwnProperty(item.attribute_code) ? input : address}
                                                handleChange={handleChange}
                                                translationsData={translationsData}
                                            />
                                        </div>
                                    )
                                case "date":
                                    return (
                                        <div
                                            className={`${cls["form-group"]} ${cls["input-paddings"]}`}
                                            style={{width: "100%"}}
                                        >
                                            <DateField
                                                item={item}
                                                index={index}
                                                // @ts-ignore
                                                savedFormData={input?.hasOwnProperty(item.attribute_code) ? input : address}
                                                handleChange={handleChange}
                                                translationsData={translationsData}
                                            />
                                        </div>
                                    )
                                case "boolean":
                                    return (
                                        <div
                                            className={`${cls["form-group"]} ${cls["input-paddings"]}`}
                                            style={{width: "100%"}}
                                        >
                                            <YesNoRadio
                                                //@ts-ignore
                                                savedFormData={input?.hasOwnProperty(item.attribute_code) ? input : address}
                                                item={item}
                                                index={index}
                                                handleChange={handleChange}
                                                translationsData={translationsData}
                                            />
                                        </div>
                                    )
                                case "radio":
                                    return (
                                        <div
                                            className={`${cls["form-group"]} ${cls["input-paddings"]}`}
                                            style={{width: "100%"}}
                                        >
                                            <RadioButton
                                                //@ts-ignore
                                                savedFormData={input?.hasOwnProperty(item.attribute_code) ? input : address}
                                                item={item}
                                                index={index}
                                                handleChange={handleChange}
                                                translationsData={translationsData}
                                            />
                                        </div>
                                    )
                                case "multiselect":
                                    return (
                                        <SelectField
                                            item={item}
                                            index={index}
                                            translationsData={translationsData}
                                            handleChange={
                                                handleChange as unknown as (
                                                    event: {
                                                        target: {
                                                            value: string;
                                                            name?: string | undefined;
                                                        };
                                                    }, item: string
                                                ) => void
                                            }
                                            // @ts-ignore
                                            savedFormData={input?.hasOwnProperty(item.attribute_code) ? input : address}
                                        />
                                    )
                            }
                        })}
                        <div className={`${cls["form-group"]} ${cls["input-paddings"]}`}>
                            <CustomTextField
                                handleChange={handleChange}
                                name="email"
                                value={translationsData.Email}
                                inpValue={input.email}
                                type="email"
                            />
                            {
                                errors &&
                                errors.email !== undefined &&
                                <div className="alert-danger">
                                    {translationsData.TheEmailMustBeAValidEmailAddress}
                                </div>
                            }
                        </div>
                        <div className={`${cls["form-group"]} ${cls["input-paddings"]}`}
                             style={{position: "relative"}}>
                            <button
                                className={cls["button-change-password"]}
                                style={{background: "transparent"}}
                                onClick={() => {
                                    dispatch(setPopup(true));
                                    dispatch(setPopupName("passwordChange"));
                                }}
                            >
                                {translationsData.ChangePassword}
                                <ChangepasSvg/>
                            </button>
                        </div>
                        <div className={`${cls["form-group"]} ${cls["input-paddings"]}`}>
                            <CustomTextField
                                handleChange={(e) => handleChange(e, "integer")}
                                name="phone"
                                value={translationsData.Phone}
                                inpValue={input.phone}
                                type="phone"
                            />
                        </div>
                    </div>
                </div>

                <div className={cls["account-contact_person"]}>{translationsData.ContactPerson + ":"}</div>
                <div className={cls.card_grid}>
                    {/*firstName*/}
                    <div className={`${cls["form-group"]} ${cls["input-paddings"]}`}>
                        <CustomTextField
                            name="first_name"
                            handleChange={handleChange}
                            inpValue={input.first_name}
                            value={translationsData.FirstName}
                        />
                        {
                            errors &&
                            errors.first_name !== undefined &&
                            <div className="alert-danger">
                            {translationsData.TheFirstNameFieldIsRequired}
                            </div>
                        }
                    </div>
                    {/*lastName*/}
                    <div className={`${cls["form-group"]} ${cls["input-paddings"]}`}>
                        <CustomTextField
                            name="last_name"
                            handleChange={handleChange}
                            inpValue={input.last_name}
                            value={translationsData.LastName}
                        />
                        {
                            errors &&
                            errors.last_name !== undefined &&
                            <div className="alert-danger">
                                {translationsData.TheLastNameFieldIsRequired}
                            </div>
                        }
                    </div>
                    {/*email and phone number*/}
                    {customFieldGenerate.map((item: any, index: number) => {
                        switch (`${item.type}-${item.attribute_code}`) {
                            case "textfield-contactpersonemail":
                                return <div
                                    className={`${cls["form-group"]} ${cls["input-paddings"]}`}
                                    style={{width: "100%"}}
                                >
                                    <TextField
                                        item={item}
                                        index={index}
                                        translationsData={translationsData}
                                        // @ts-ignore
                                        savedFormData={input?.[item.attribute_code] ? input : address}
                                        handleChange={handleChange}
                                        urlValidate={urlValidate}
                                    />
                                </div>
                            case "textfield-contactpersonphonenumber":
                                return <div
                                    className={`${cls["form-group"]} ${cls["input-paddings"]}`}
                                    style={{width: "100%"}}
                                >
                                    <TextField
                                        item={item}
                                        index={index}
                                        translationsData={translationsData}
                                        // @ts-ignore
                                        savedFormData={input?.[item.attribute_code] ? input : address}
                                        handleChange={handleChange}
                                        urlValidate={urlValidate}
                                    />
                                </div>
                        }
                    })}
                </div>

                <div className={cls["account-save-profile"]}>
                    <button
                        onClick={handleClick}
                        type="button"
                        className={
                            !loading
                                ? "btn btn-primary btn-primary-fms"
                                : "btn btn-primary btn-primary-fms"
                        }
                    >
                        {translationsData.SaveChanges}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AccountPageProfile;
